import React, { useState } from 'react'
import FactoryLeadTimeDisplay from 'src/component/Product/FactoryLeadTimeDisplay';
import newImg from "src/assets/images/new.png"
import System from 'src/helper/system';
import { Tooltip } from 'src/component/Tooltip';
import liveAuth from "../../../helper/liveAuth";
import Constants from "src/support/Constants";
import ProductInventoryAPICall from "../../../service/ProductInventoryAPICall";
import RefreshStockButton from "../../../pages/ProductListing/RefreshStockButton";

const ProductInventoryDisplay = (props) => {
    const { single_product, single_product_inventory, isFrom } = props;
    const noAdditionalInventoryComps = [
        Constants.isFrom.PDP,
        Constants.isFrom.CART_LIST,
        Constants.isFrom.BOM_ALT_POPUP,
        Constants.isFrom.OPEN_QUOTE,
    ]

    const showFarnellInventory = (ERPPartNumber) => {
        System.popup('FarnellInventoryStockPopup', {
            ERPPartNumber
        })
    }

    const authLoggedIn = () => {
        return liveAuth.check();
    };



    return (
        <ul className="list-text availibility-list-text mb-3">
            {isFrom === Constants.isFrom.PDP &&
                <li className="stock-price-title">
                     <span
                         className="d-flex text-darkgreen w-100 justify-content-between">
                    <span className='fs-5'>
                        <b>In Stock: </b>
                        <b className="ms-auto">{single_product_inventory?.qas}</b>
                    </span>
                    <RefreshStockButton
                        fetchInventoryFromServer={async () => {
                            if (single_product) {
                                await new ProductInventoryAPICall().getInventory([
                                    {
                                        sboat: single_product.Sboat,
                                        ERPManufacturerCode: single_product.ERPManufacturerCode,
                                        ERPPartNumber: single_product.ERPPartNumber
                                    }
                                ], true)
                            }
                        }}
                    />
                    </span>
                </li>
            }
            {isFrom !== Constants.isFrom.PDP && <>
                <li className="text-darkgreen">
                    <span
                        className="d-flex text-darkgreen w-100">
                        <b>In Stock:</b>
                        <b className="ms-auto">{single_product_inventory?.qas}</b>
                        <i className="fa fa-check-circle ms-2"></i>
                    </span>
                    </li>
                    {isFrom !== Constants.isFrom.CART_LIST && <li>
                        <div className='seprator-dashed'></div>
                    </li>}
                </>}
                {!noAdditionalInventoryComps.includes(isFrom) && <li>
                    <i className="fa fa-level-up me-2 d-none"></i>
                    <span>
                        <b className={isFrom === Constants.isFrom.QUOTE_DETAIL ? '' : 'text-uppercase'}>Additional Inventory</b>
                    </span>
                </li>}
            <li>
                <div className='w-100 flex-column'>
                        <FactoryLeadTimeDisplay
                            single_product={single_product}
                            single_product_inventory={single_product_inventory}
                        />
                </div>
            </li>
            {isFrom === Constants.isFrom.QUOTE_DETAIL && <li>
                Min/Mult: {single_product.Min}/{single_product.Mult}
            </li>}
            {single_product?.FarnellInventorySharing && (isFrom === Constants.isFrom.PLP || isFrom === Constants.isFrom.COMPARE) &&
                <li>
                    <a className="d-flex align-items-center mt-2 text-blue cursor-pointer" onClick={() => showFarnellInventory(single_product?.ERPPartNumber)}> <img src={newImg} />
                        <Tooltip
                            position={'top center'}
                            opener={() => (
                                <span className="text-ports ms-2"><b>Stock from Farnell, an Avnet company</b></span>
                            )}
                            content={() => (
                                <>
                                    <div>
                                        Farnell, an Avnet company offers a wide range of products to meet your needs.
                                    </div>
                                </>
                            )} /></a>
                </li>
            }
        </ul>
    )
}

export default ProductInventoryDisplay

